import React from 'react';

import type { NewLayoutPlacement } from '@neptune/shared/grid-layout-domain';

export type SecondaryStyleDraftScope = {
  id: string;
  keys: readonly string[];
  widgetId?: string;
  placement?: NewLayoutPlacement;
};

type SecondaryStylesContext = {
  getSecondaryPattern: (key: string, scope?: string) => number[] | undefined;
  getSecondaryColor: (key: string, scope?: string) => string | undefined;
  registerDraftScope?: (draft: SecondaryStyleDraftScope) => () => void;
};

export const SecondaryStylesContext = React.createContext<SecondaryStylesContext>({
  getSecondaryPattern: () => undefined,
  getSecondaryColor: () => undefined,
});
